// FILECONTENT_START src/common/components/UploadButton/UploadAvatarButton.tsx
import { Avatar, AvatarProps, Tooltip } from "@mui/material";
import { ReactNode } from "react";
import useUploadButton, { UseUploadButtonProps } from "./useUploadButton";

export enum UploadFileTypes {
  DocumentsAndImages = ".csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .png, image/png, jpg, image/jpg, jpeg, image/jpeg, .pdf, application/pdf",
  ExcelCsv = ".csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
}

export interface UploadAvatarButtonProps
  extends UseUploadButtonProps,
    Omit<AvatarProps<any>, "onChange" | "onClick" | "component" | "children"> {
  onValidate?: Function;
  title?: string;
  children?: ReactNode;
}

export default function UploadAvatarButton({
  onChange,
  multiple,
  accept,
  children,
  onValidate,
  title,
  ...avatarProps
}: UploadAvatarButtonProps) {
  const { loading, fileInput } = useUploadButton({
    onChange,
    multiple,
    accept,
  });

  return (
    <Tooltip title={title || ""}>
      <label
        style={{ display: "inline-block", borderRadius: 100 }}
        onClick={(evt: any) => {
          if (onValidate) {
            if (!onValidate()) {
              evt.stopPropagation();
              evt.preventDefault();
            }
          }
        }}
      >
        {fileInput}
        <Avatar
          //loading={loading}
          //component="label"

          {...avatarProps}
        >
          {children}
        </Avatar>
      </label>
    </Tooltip>
  );
}

// FILECONTENT_END src/common/components/UploadButton/UploadAvatarButton.tsx